/**
 * @file LayoutSchemes.tsx
 * @description Мини-схемы вариантов шапки и подвала для карточек-вариантов
 * (phase19.16 Р1; SB13, SB14, SB90; uiux-design-r1 §2): где логотип, где
 * пункты меню, где корзина. Схема — данные (порядок блоков), а не четыре
 * разные картинки.
 */

import type { SiteTheme } from "@chaiberi/shared";

type Block = "logo" | "menu" | "cart";

/** Строки схемы шапки по месту логотипа (SB90). */
const HEADER_ROWS: Readonly<Record<SiteTheme["header"]["logoPosition"], Block[][]>> = {
  left: [["logo", "menu", "cart"]],
  center: [["menu", "logo", "menu", "cart"]],
  right: [["menu", "logo", "cart"]],
  above: [["logo"], ["menu", "cart"]],
};

const BLOCK_CLASS: Readonly<Record<Block, string>> = {
  logo: "h-3 w-6 rounded-sm bg-primary",
  menu: "h-1.5 flex-1 rounded-full bg-on-surface/30",
  cart: "size-2.5 rounded-sm bg-on-surface/50",
};

function SchemeRow({ blocks }: { blocks: Block[] }) {
  return (
    <span className="flex w-full items-center justify-center gap-1.5">
      {blocks.map((b, i) => (
        <span key={`${b}-${i}`} className={BLOCK_CLASS[b]} />
      ))}
    </span>
  );
}

export function HeaderScheme({ position }: { position: SiteTheme["header"]["logoPosition"] }) {
  return (
    <span className="flex w-full flex-col gap-1.5">
      {HEADER_ROWS[position].map((row, i) => (
        <SchemeRow key={i} blocks={row} />
      ))}
    </span>
  );
}

/** Схема подвала: «в строку» — одна полоса, «колонками» — три столбика. */
export function FooterScheme({ template }: { template: SiteTheme["footer"]["template"] }) {
  if (template === "row") {
    return (
      <span className="flex w-full flex-col gap-1.5">
        <SchemeRow blocks={["logo", "menu"]} />
        <span className="h-1 w-full rounded-full bg-on-surface/20" />
      </span>
    );
  }
  return (
    <span className="grid w-full grid-cols-3 gap-2">
      {[0, 1, 2].map((i) => (
        <span key={i} className="flex flex-col gap-1">
          <span className="h-1.5 w-full rounded-full bg-on-surface/40" />
          <span className="h-1 w-3/4 rounded-full bg-on-surface/20" />
          <span className="h-1 w-2/3 rounded-full bg-on-surface/20" />
        </span>
      ))}
    </span>
  );
}
